import { auth } from '@/firebase';

export default class AuthService {
  static async signIn({ email, password }) {
    return auth.signInWithEmailAndPassword(email, password);
  }

  static async signOut() {
    return auth.signOut();
  }

  static async sendPasswordResetEmail(userId) {
    return auth.sendPasswordResetEmail(userId);
  }
}
